import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService } from '../../../services/sagstudioService/sagtoast.service';

@Component({
  selector: 'app-sagtoast',
  templateUrl: './sagtoast.component.html',
  styleUrls: ['./sagtoast.component.scss']
})
export class SagtoastComponent implements OnInit {
  subscription: Subscription;
  textMessage: string = 'Default Msg';
  textType: string = '';
  textPosition: string = '';

  constructor(
    public _toast: ToastService,
    private _cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.subscription = this._toast.toastMSG.subscribe((responseObj) => {
      this._cdRef.detectChanges();
      if (responseObj.message !== '') {
        this.textMessage = responseObj.message;
        this.textPosition = responseObj.position;
        this.textType = responseObj.type;
        const x = document.getElementById('ujx_toast')
        x.className = 'ujx_show'
        setTimeout(function () { x.className = x.className.replace("ujx_show", ""); }, 5000);
      }
    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
